import http from "./httpService";

const apiEndpoint = http.apiUrl + "article-notification";

// service is used to create article
export function senArticleNotifiction(data) {
  return http.post(apiEndpoint, data);
}
